'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Props {
  sortBy: string;
  setSortBy: (v: string) => void;
  activeTab: string;
  resultCount: number;
}

const sortOptions = [
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'duration-asc', label: 'Duration: Shortest' },
  { value: 'rating-desc', label: 'Rating: Best First' },
  { value: 'deal-score', label: 'Best Deal Score' },
];

export default function ResultsHeader({ sortBy, setSortBy, activeTab, resultCount }: Props) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4 py-3 border-b border-border">
      <div>
        <p className="text-sm text-muted-foreground">
          <span className="font-700 text-foreground tabular-nums">{resultCount.toLocaleString()}</span> results for{' '}
          <span className="font-semibold text-foreground">New York → London</span>
          {activeTab === 'hotels' && <span> · Jun 14–21 (7 nights)</span>}
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Prices include all taxes and fees. Updated 3 minutes ago.
        </p>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground font-medium">Sort by:</span>
        <div className="relative">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="input-base pl-3 pr-8 py-2 text-sm font-semibold appearance-none cursor-pointer min-w-[180px]"
          >
            {sortOptions.map((opt) => (
              <option key={`sort-${opt.value}`} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <Icon
            name="ChevronDownIcon"
            size={14}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
        </div>
      </div>
    </div>
  );
}